import { useTrackView } from 'src/app/shared/hooks/tracking';

export function useTrackPageView(): void {
	useTrackView('searchpage_view');
}
